/* eslint-disable no-underscore-dangle */
import L from 'leaflet';
import { isNaN } from 'lodash';

const CONTAINER_STYLE = `
  cursor: pointer;
  font: 18px 'Lucida Console',Monaco,monospace;
  position: relative;
  top: 44px;
  height: 34px;
  width: 34px;
`;

L.Control.Level = L.Control.extend({
  includes: L.Evented,

  options: {
    position: 'topright',
    parseLevel(level) {
      if (!isNaN(parseInt(level, 10))) return parseInt(level, 10);
      return `${level}`;
    }
  },

  initialize(options) {
    L.setOptions(this, options);
    this._map = null;
    this._buttons = {};
    this._listeners = [];
    this._level = options.level;
  },

  onAdd() {
    const div = L.DomUtil.create('div', 'leaflet-bar leaflet-control-button');
    L.DomEvent.disableClickPropagation(div);

    div.style = CONTAINER_STYLE;

    const buttons = this._buttons;
    const activeLevel = this._level;
    const self = this;

    const levels = [];

    for (let i = 0; i < this.options.levels.length; i += 1) {
      const level = this.options.levels[i];
      const levelNum = self.options.parseLevel(level);
      levels.push({ num: levelNum, label: level });
    }

    levels.sort((a, b) => a.num - b.num);

    for (let i = levels.length - 1; i >= 0; i -= 1) {
      const level = levels[i].num;
      const originalLevel = levels[i].label;

      const levelBtn = L.DomUtil.create('a', 'leaflet-buttons-control-button', div);
      levelBtn.setAttribute('role', 'button');
      levelBtn.style.cursor = 'pointer';

      if (level === activeLevel || originalLevel === activeLevel)
        levelBtn.style.backgroundColor = '#b0b0b0';

      levelBtn.appendChild(levelBtn.ownerDocument.createTextNode(originalLevel));

      (innerLevel => {
        levelBtn.onclick = () => self.setLevel(innerLevel);
      })(level);

      buttons[level] = levelBtn;
    }

    return div;
  },

  setLevel(level) {
    if (level === this._level) return;
    const oldLevel = this._level;
    this._level = level;

    if (this._map !== null) {
      if (typeof oldLevel !== 'undefined')
        this._buttons[oldLevel].style.backgroundColor = '#FFFFFF';
      this._buttons[level].style.backgroundColor = '#b0b0b0';
    }

    if (typeof this.options.indoorLayer.setLevel === 'function')
      this.options.indoorLayer.setLevel({ oldLevel, newLevel: level });
  },

  getLevel() {
    return this._level;
  }
});

L.control.level = opts => new L.Control.Level(opts);

/**
 * Adds the control for the level of an indoor layer.
 *
 * @param {object} options - The leaflet map.
 * @returns {object} The level control.
 */
const customLevelControl = options => L.control.level(options);

export default customLevelControl;
